import React, { Component, createRef } from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import CopyToClipboard from '@components/CopyToClipboard/CopyToClipboard';
import Tooltip from 'elements/Tooltip/Tooltip';
import { ListElement } from 'elements/Tooltip/Layout';
import Icon from 'foundations/Icons/Icon';
import styles from './TextStyle.css';

const cx = classnames.bind(styles);

/*
  Presentational component for a single Text Style
*/

class TextStyle extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    rows: PropTypes.number,
    items: PropTypes.array
  };

  static defaultProps = {
    rows: 2,
  }

  textAreaRef = createRef();
  inputRef = createRef();

  text = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

  state = {
    hasOverlay: true
  }

  handleOverlayClick = () => {
    const { items } = this.props;
    let targetElement = items ? this.inputRef : this.textAreaRef;

    targetElement = targetElement.current;
    targetElement.focus();

    this.setState({ hasOverlay: false });
  }

  handleTextAreaBlur = () => {
    const textArea = this.textAreaRef.current;

    if (textArea.placeholder === '') {
      textArea.placeholder = this.text;
    }

    this.setState({ hasOverlay: true });
  }

  renderOverlay = () => {
    return (
      <div
        className={classnames(styles.overlay, 'flex flex-align-center flex-justify-center')}
        onClick={this.handleOverlayClick}
      >
        <span className="section-title">Click to write</span>
      </div>
    );
  }

  renderTextArea = () => {
    const { className, rows, type } = this.props;

    const textAreaClass = classnames(
      className.replace('.', ' '),
      styles.textArea,
      type
    );

    return(
      <textarea
        className={textAreaClass}
        rows={rows}
        placeholder={this.text}
        ref={this.textAreaRef}
        onBlur={this.handleTextAreaBlur}
      />
    );
  }

  renderItems = () => {
    const { items, className } = this.props;
    if(!items) { return null;}

    const inputClassName = classnames(
      className.replace('.', ' '),
      styles.input
    );

    return items.map((textItem, i) => {
      return (
        <input
          ref={i === 0 ? this.inputRef : ''}
          className={inputClassName}
          key={`textItem-${i}`}
          type="text"
          placeholder={textItem}
        />);
    });
  }

  renderCopyToClipboard = () => {
    const { className } = this.props;

    return(
      <div>
        <CopyToClipboard
          dataText={className}
          render={ copied =>
            <Tooltip
              target={
                <Icon
                  icon={copied ? 'confirmation' : 'duplicate'}
                  type={'20'}
                  customClasses={cx('copyIcon', { 'active': copied })} />
              }
              open={copied}
              placement={'top'}
            >
              <ListElement>Text Style Copied!</ListElement>
            </Tooltip>
          }
        />
      </div>
    );
  }

  render() {
    const { hasOverlay } = this.state;
    const { name, className, description, items } = this.props;

    const textStyleClasses = classnames(
      styles.textStyleWrapper,
      'flex flex-column flex-justify-between'
    );

    return (
      <div className={textStyleClasses}>
        <div className={classnames(styles.top, 'flex flex-grow-1 flex-justify-center flex-column')}>

          { !items && this.renderTextArea() }
          { this.renderItems() }
          { hasOverlay && this.renderOverlay() }

        </div>

        <div className={classnames(styles.bottom, 'flex')}>
          <div className="left">
            <p className="copy">{name}:</p>
            <span className="copy">{description}</span>
          </div>
          <div className="right flex flex-justify-between flex-align-center">
            <div>
              <p className="copy">CSS Class:</p>
              <span className="copy">{className}</span>
            </div>
            { this.renderCopyToClipboard() }
          </div>
        </div>

      </div>
    );
  }
}

export default TextStyle;



// WEBPACK FOOTER //
// ./src/containers/foundations/TextStyles/TextStyle/TextStyle.js